var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.953,
    height: 15.571,
    viewBox: "0 0 15.953 15.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Condition",
    d: "M-6464.286-618.826l1.009-1.011,1.009,1.011,2.018-2.019,1.008,1.008-3.025,3.027Zm-8.892,1.008-1.009,1.008-1.009-1.008,1.009-1.008-1.009-1.011,1.009-1.008,1.009,1.008,1.01-1.008,1.009,1.008-1.009,1.011,1.009,1.008-1.009,1.008Zm2.743-5.288h-2.266v1.427h-.952v-2.379h3.218l2.489-1.246v-2.083h.952v2.083l2.49,1.246h3.217v2.379h-.952v-1.427h-2.265l-2.964,1.483Zm1.174-.477,1.792.9,1.789-.9-1.789-.893Zm-.35-6.656a2.144,2.144,0,0,1,2.14-2.141,2.144,2.144,0,0,1,2.141,2.141,2.142,2.142,0,0,1-2.141,2.139A2.142,2.142,0,0,1-6469.611-630.239Zm1.427,0a.713.713,0,0,0,.712.712.714.714,0,0,0,.715-.712.716.716,0,0,0-.715-.715A.715.715,0,0,0-6468.184-630.239Z",
    transform: "translate(6475.196 632.381)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCondition);
export default __webpack_public_path__ + "static/media/Icon_Condition.6f83eca7.svg";
export { ForwardRef as ReactComponent };